import React from "react";

const AboutMe = () => {
  return (
    <React.Fragment>
      <div className="aboutme" id="aboutme">
        <div className="container">
          <h1>Internships</h1>
          <ul>
            <li>Solera Private Limited</li>
            <li>Academic Internship NUS, Singapore </li>
            <li>Hindustan Coca-Cola Beverage Company Limited</li>
            <li>Ashok Leyland </li>
          </ul>
        </div>
        <div className="container">
          <h1> SkillSets</h1>
          <ul>
            <li>Adobe XD and Figma</li>
            <li>IOT and Robotics</li>
            <li>React JS</li>
            <li>NodeJS</li>
            <li>HTML/CSS and JS</li>
            <li>MySQL and MongoDB</li>
            <li>PHP and Python</li>
            <li>C and C++</li>
            <li>AutoCAD</li>
            <li>Fusion 360 and Catia</li>
            <li>Raspberry Pi and Arduino</li>
          </ul>
        </div>
        <div className="container">
          <h1>Competitions</h1>
          <ul>
            <li>Ford Virtual Commissioning Hackathon-Third Place</li>
            <li>Invente 3.0-Arduino Quiz(SSN)-Third Place</li>
            <li>RoboVITics (VITC)=Secured Fourth Position</li>
            <li>SASTRA 2018 - Robotics (IITM)-Participated</li>
          </ul>
        </div>
        <div className="container">
          <h1>Education</h1>
          <ul>
            <li>B.Tech - IIITDM Kancheepuram - 8.1 CGPA (2021 graduation)</li>
            <li>12th - Maharishi Vidya Madir - 94%(2017 Batch)</li>
            <li>10th - St. John's SSS - 9 CGPA(2015 Batch)</li>
          </ul>
        </div>
      </div>
    </React.Fragment>
  );
};
export default AboutMe;
